import {PublicClientApplication, type AccountInfo, type RedirectRequest} from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID || '',
    authority: process.env.VUE_APP_AUTHORITY || '',
    redirectUri: `${window.location.origin}/portal/advisorlogin`,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const graphScopes: RedirectRequest = {
  scopes: ['openid', 'profile', 'offline_access', process.env.VUE_APP_API_SCOPES || ''],
};

export const state = {
  isAuthenticated: false,
  user: null as AccountInfo | null,
};

export const msalInstance = new PublicClientApplication(msalConfig);
